import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: (props) =>
      props.transparent ? undefined : theme.props.backgroundColor.primary.main,
    border: `1px solid ${theme.props.border.secondary.main}`,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2, 3),
    },
  },
}));

type BorderBoxProps = React.HTMLAttributes & {
  transparent?: boolean,
  classes?: { [key: 'root']: string },
};

const BorderBox = ({ transparent, ...props }: BorderBoxProps) => {
  const classes = useStyles({ transparent, ...props });
  return <div {...props} className={clsx(classes.root, props?.className)} />;
};

export default BorderBox;
